import { render, staticRenderFns } from "./td-reportOpt.vue?vue&type=template&id=ff21c1de&"
import script from "./td-reportOpt.vue?vue&type=script&lang=js&"
export * from "./td-reportOpt.vue?vue&type=script&lang=js&"
import style0 from "./td-reportOpt.vue?vue&type=style&index=0&id=ff21c1de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports